

export default{

    //for app submission
    showFakeMobile: false,
}

